export default "__VITE_ASSET__gDchvJYEg_PEfG8UvJklmg__"